module.exports = __webpack_public_path__ + "img/thirteen.d6f2a02b.png";